import React from "react";
import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { captureAttributionOnLanding } from "./lib/attribution";
import { captureClaimTokenFromUrl } from "./lib/claim/claimTokenCapture";

// Claimtoken als allereerste uit de URL halen (vóór analytics/Sentry).
captureClaimTokenFromUrl();

// First-touch attributie capture: leest gclid/utm_* uit URL, landing pathname
// en referrer-origin en bewaart in sessionStorage. Wordt PAS bij een echte
// lead-submit naar onze backend gestuurd. Geen third-party calls.
captureAttributionOnLanding();

createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Defer Sentry initialization so it doesn't block the critical render path.
// Error tracking still kicks in shortly after first paint via dynamic import.
if (typeof window !== "undefined") {
  const loadSentry = () => {
    import("./lib/sentry").catch((err) => {
      // Never let Sentry init crash the app
      console.warn("[Sentry] Deferred init failed:", err);
    });
  };

  const schedule = () => {
    if ("requestIdleCallback" in window) {
      (window as any).requestIdleCallback(loadSentry, { timeout: 3000 });
    } else {
      setTimeout(loadSentry, 1500);
    }
  };

  if (document.readyState === "complete") {
    schedule();
  } else {
    window.addEventListener("load", schedule, { once: true });
  }
}
